<script setup lang="ts">
import FlashIcon from "@/components/ui/FlashIcon.vue";
import type { InfoLevel } from "@/model/baseTypes";

defineProps<{ states: InfoLevel[] }>();
</script>

<template>
  <div>{{ $t("linkState.title") }}</div>
  <FlashIcon v-for="state in states" :key="state" :link-state="state" class="flash-icons-tooltip" />
</template>

<style scoped lang="scss">
.flash-icons-tooltip {
  margin-left: 10px;
}
</style>
